import type { Template } from "@/types";

export const PO_02_H2_V0: Template[] = [
    {
        id: "po-02-h2v0-01",
        name: "PO 01 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 233, width: 683, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 233, width: 683, height: 451, rotation: 0, imageRotation: 0 }
        ],
    },
 
    {
        id: "po-02-h2v0-02",
        name: "PO 02 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 264, width: 590, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 264, width: 590, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-03",
        name: "PO 03 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 82, y: 264, width: 601, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 264, width: 601, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

     {
        id: "po-02-h2v0-04",
        name: "PO 04 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_04.png",
        size: [1374, 916],
        style: {},
         slots: [
             { id: "1", x: 44, y: 264, width: 601, height: 389, rotation: 0, imageRotation: 0 },
             { id: "2", x: 806, y: 313, width: 448, height: 290, rotation: 0, imageRotation: 0 }
         ],
    },

      {
        id: "po-02-h2v0-05",
        name: "PO 05 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_05.png",
        size: [1374, 916],
        style: {},
          slots: [
              { id: "1", x: 120, y: 313, width: 448, height: 290, rotation: 0, imageRotation: 0 },
              { id: "2", x: 729, y: 264, width: 601, height: 389, rotation: 0, imageRotation: 0 }     
          ],
    },

    {
        id: "po-02-h2v0-06",
        name: "PO 06 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 476, width: 590, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 476, width: 590, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-07",
        name: "PO 07 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 806, y: 313, width: 448, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 119, y: 313, width: 448, height: 290, rotation: 0, imageRotation: 0 }
        ],
    },
];




